import React from "react";

import { QRFRameProps } from "../types";

import { getPreviewFrameFontSize } from "@/utils/qrEditorHelper";

import "../styles.scss";

export const celebrationFrame = (
  props: Omit<QRFRameProps, "frameType">
): React.SVGProps<SVGSVGElement> => {
  const { text, textColor, children, frameColor, frameBackgroundColor, urlQr } = props;

  const fontSize = getPreviewFrameFontSize(text?.length);

  return (
    <svg
      width="96"
      height="128"
      viewBox="0 0 96 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        fill="white"
      />
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        stroke="#BFBFBF"
      />
      <g opacity="0.97">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M47.6289 9.03169C48.1525 8.9286 48.5854 9.07704 48.9277 9.477C49.4007 10.4353 49.8831 11.3877 50.375 12.3344C51.488 12.5253 52.6013 12.7232 53.7148 12.9282C54.3716 13.3399 54.5324 13.8965 54.1973 14.5981C53.4304 15.365 52.6634 16.1319 51.8965 16.8989C52.0244 17.9636 52.1852 19.0274 52.3789 20.0903C52.2368 21.0614 51.6925 21.4201 50.7461 21.1665C49.8215 20.6989 48.9061 20.2165 48 19.7192C47.0197 20.2464 46.0301 20.7536 45.0312 21.2407C44.1299 21.3476 43.6598 20.9518 43.6211 20.0532C43.7663 19.021 43.9395 17.9943 44.1406 16.9731C43.422 16.1926 42.6675 15.4504 41.877 14.7465C41.4499 14.0346 41.5612 13.4285 42.2109 12.9282C43.3217 12.7253 44.435 12.5398 45.5508 12.3715C46.0521 11.443 46.5345 10.5029 46.998 9.55122C47.1774 9.33425 47.3877 9.16107 47.6289 9.03169ZM49.6328 17.9379C49.2657 17.7544 48.8946 17.5688 48.5195 17.3813C48.2296 17.2749 47.9328 17.2502 47.6289 17.3071C47.2083 17.5173 46.7878 17.7277 46.3672 17.9379C46.3425 17.9132 46.3177 17.8884 46.293 17.8637C46.4663 17.3065 46.5282 16.7374 46.4785 16.1567C46.1297 15.6586 45.7215 15.2009 45.2539 14.7836C45.8626 14.7215 46.4564 14.5979 47.0352 14.4125C47.1465 14.3012 47.2578 14.1899 47.3691 14.0786C47.5606 13.671 47.7708 13.2751 48 12.8911C48.2292 13.2751 48.4394 13.671 48.6309 14.0786C48.7971 14.2939 49.0074 14.4548 49.2617 14.561C49.734 14.6214 50.2041 14.6956 50.6719 14.7836C50.2332 15.1725 49.8498 15.6054 49.5215 16.0825C49.4809 16.7055 49.518 17.324 49.6328 17.9379Z"
          fill={frameColor}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M67 45.3247C67 45.5968 67 45.8689 67 46.1411C66.8407 46.461 66.5933 46.6961 66.2578 46.8461C54.0859 46.8956 41.9141 46.8956 29.7422 46.8461C29.4067 46.6961 29.1593 46.461 29 46.1411C29 45.8689 29 45.5968 29 45.3247C30.5528 43.338 32.1238 41.3589 33.7129 39.3872C33.7376 38.5212 33.7624 37.6554 33.7871 36.7895C34.0681 35.4693 34.835 34.5539 36.0879 34.0434C36.125 31.5695 36.1374 29.0956 36.125 26.6215C35.4071 26.6339 34.6897 26.6215 33.9727 26.5844C33.2738 26.3126 33.014 25.8054 33.1934 25.0629C33.4858 24.4693 33.9682 24.2096 34.6406 24.2836C33.7503 23.2211 33.5153 22.0212 33.9355 20.684C34.7933 18.8017 36.2406 18.0719 38.2773 18.4946C40.1334 19.1992 40.9622 20.5475 40.7637 22.5395C40.6269 23.1966 40.3423 23.7779 39.9102 24.2836C41.1832 24.3444 41.6162 24.9752 41.209 26.1762C41.0945 26.3156 40.9584 26.4269 40.8008 26.5102C40.2623 26.6011 39.718 26.6506 39.168 26.6586C40.9096 28.6683 43.0866 29.9795 45.6992 30.5922C48.1991 31.1222 50.5988 30.8254 52.8984 29.7016C54.4698 28.996 55.8057 27.9817 56.9062 26.6586C56.3315 26.651 55.7625 26.6016 55.1992 26.5102C54.6958 26.1885 54.5102 25.7308 54.6426 25.1372C54.752 24.7309 55.0117 24.4711 55.4219 24.3579C55.6445 24.3331 55.8672 24.3084 56.0898 24.2836C54.9719 22.8103 54.9101 21.2888 55.9043 19.7192C57.2569 18.2712 58.8278 17.9867 60.6172 18.8657C62.3427 20.2387 62.7014 21.9086 61.6934 23.8754C61.5731 24.0047 61.4618 24.1408 61.3594 24.2836C62.4698 24.2558 62.9523 24.7877 62.8066 25.8793C62.6636 26.2451 62.4039 26.4801 62.0273 26.5844C61.3103 26.6215 60.5928 26.6339 59.875 26.6215C59.8626 29.0956 59.875 31.5695 59.9121 34.0434C61.165 34.5539 61.9319 35.4693 62.2129 36.7895C62.2376 37.6554 62.2624 38.5212 62.2871 39.3872C63.8762 41.3589 65.4472 43.338 67 45.3247ZM36.9414 20.684C38.2321 20.6936 38.6897 21.3121 38.3145 22.5395C37.741 23.2329 37.0977 23.3071 36.3848 22.7622C35.8089 21.8617 35.9944 21.1689 36.9414 20.684ZM58.3906 20.684C59.682 20.6956 60.1397 21.3141 59.7637 22.5395C59.078 23.3296 58.3853 23.3296 57.6855 22.5395C57.3438 21.6964 57.5788 21.0779 58.3906 20.684ZM38.4258 29.3676C41.5136 32.0835 45.1256 33.3328 49.2617 33.1157C52.4221 32.7232 55.1806 31.4739 57.5371 29.3676C57.5866 30.9262 57.5866 32.4848 57.5371 34.0434C56.2866 34.5519 55.5197 35.4672 55.2363 36.7895C55.1992 37.4075 55.1869 38.026 55.1992 38.645C50.3997 38.645 45.6003 38.645 40.8008 38.645C41.086 36.9985 40.616 35.6255 39.3906 34.5258C39.0966 34.3355 38.7873 34.1747 38.4629 34.0434C38.4258 32.485 38.4134 30.9264 38.4258 29.3676ZM36.8672 36.1957C37.6742 36.0769 38.2061 36.3984 38.4629 37.1606C38.5 37.6547 38.5123 38.1496 38.5 38.645C37.6836 38.645 36.8672 38.645 36.0508 38.645C36.0384 38.1248 36.0508 37.6053 36.0879 37.0864C36.2316 36.6832 36.4913 36.3863 36.8672 36.1957ZM58.3906 36.1957C59.0297 36.0887 59.5121 36.3113 59.8379 36.8637C59.9419 37.4512 59.979 38.0449 59.9492 38.645C59.1328 38.645 58.3164 38.645 57.5 38.645C57.4877 38.1248 57.5 37.6053 57.5371 37.0864C57.6889 36.6503 57.9734 36.3534 58.3906 36.1957ZM35.457 40.9457C43.8439 40.921 52.2306 40.9457 60.6172 41.02C61.5714 42.1844 62.5115 43.3595 63.4375 44.5454C53.1458 44.5949 42.8542 44.5949 32.5625 44.5454C33.5191 43.3364 34.4839 42.1366 35.457 40.9457Z"
          fill={frameColor}
        />
      </g>

      <rect
        x="23"
        y="50"
        width="50"
        height="50"
        rx="2"
        fill={frameBackgroundColor}
      />
      <foreignObject
        width="44%"
        height="41px"
        style={{ borderRadius: "3px" }}
        x="27"
        y="54">
        <div
          id="#qrCode"
          style={{
            border: `1px solid ${frameBackgroundColor || "white"}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            backgroundColor: `${frameBackgroundColor}`,
          }}>
          {urlQr ? (
            <img
              src={urlQr}
              width="100%"
              height="auto"
            />
          ) : (
            children
          )}
        </div>
      </foreignObject>
      <foreignObject
        width="100%"
        height="18px"
        y="102">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: "100%", height: "100%", maxWidth: "100%" }}>
          <text
            x="50%"
            y="11"
            fill={textColor}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="sans-serif"
            fontWeight="bold"
            style={{ fontSize }}>
            {text}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
